
import React from "react";
import { useUsageTrackerData } from "./useUsageTrackerData";
import LoadingState from "./LoadingState";
import EmptyGroupsState from "./EmptyGroupsState";
import { useGroupActions } from "./hooks/useGroupActions";
import UsageTrackerHeader from "./UsageTrackerHeader";
import GroupsGrid from "./GroupsGrid";
import { transformGroupsWithProducts } from "./utils/transformGroupData";

export const QuickUsageTracker = () => {
  const {
    groups,
    products,
    isLoading,
    error,
    groupProductQuantities,
    handleRetry
  } = useUsageTrackerData();
  
  const { handleAddGroup, handleTrackGroupUsage } = useGroupActions();
  
  // If data is still loading, show loading state
  if (isLoading) {
    return (
      <div className="card-container">
        <LoadingState onRetry={handleRetry} />
      </div>
    );
  }
  
  // If there are no groups, show empty state
  if (groups.length === 0) {
    return (
      <div className="card-container">
        <EmptyGroupsState onAddGroup={handleAddGroup} />
      </div>
    );
  }
  
  // Transform groups data with their products
  const groupsWithProducts = transformGroupsWithProducts(
    groups,
    products,
    groupProductQuantities
  );
  
  return (
    <section className="card-container">
      <UsageTrackerHeader 
        onRefresh={handleRetry}
        onAddGroup={handleAddGroup}
      />
      
      <GroupsGrid 
        groups={groupsWithProducts}
        onTrackUsage={handleTrackGroupUsage}
        onAddGroup={handleAddGroup}
      />
    </section>
  );
};

export default QuickUsageTracker;
